module.exports = __webpack_public_path__ + "img/robitussin_adult_cough_chest_congestion_dm_liquid_filled_capsules_maximum_strength.d97baa6a.jpg";